import React from 'react';
import { Tooltip } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { WarningType } from './types';

interface MandatoryWarningIconProps {
  warningType?: WarningType;
}

const TOOLTIP_TEXT: Record<WarningType, string> = {
  transform_error: 'Configuration/ value error',
  missing: 'Required field is empty',
};

export const MandatoryWarningIcon: React.FC<MandatoryWarningIconProps> = ({
  warningType = 'missing',
}) => {
  return (
    <Tooltip title={TOOLTIP_TEXT[warningType]} arrow placement="top">
      <WarningIcon
        sx={{ fontSize: '1rem', color: 'warning.main', flexShrink: 0 }}
      />
    </Tooltip>
  );
};
